// Dependencies
import styled from 'styled-components';

const BlogPostRelatedPostsStyles = styled.section`
  margin: ${(props) => (props?.flexibleContent ? '0' : '4rem')} 0 0;
  padding-top: ${(props) => (props?.bgColor ? '2.5rem' : '0')};
  text-align: center;
  background-color: var(--color-${(props) => props?.bgColor});

  .heading {
    font-weight: var(--font-weight-regular);
  }

  .posts {
    margin: 2.5rem 0 0 0;
    padding: 0;
    list-style: none;
  }

  @media (min-width: 768px) {
    .posts {
      display: flex;
      justify-content: center;
      margin: 3.75rem 0 0 0;
      column-gap: 2rem;

      .post {
        width: 50%;

        &:last-child {
          display: none;
        }
      }
    }
  }

  @media (min-width: 1200px) {
    .posts {
      .post {
        width: 33.333%;

        &:last-child {
          display: block;
        }
      }
    }
  }

  @media (min-width: 1600px) {
    .posts {
      column-gap: 4rem;
    }
  }
`;

export default BlogPostRelatedPostsStyles;
